import {
  useCallback,
} from 'react'

import { useTokenDispatch } from '../../../../../../../contexts/token.context'
import useCartController from '../../../../../../../controllers/cart.controller'

const useExecuteInCatch = () => {
  const setTokenDB = useTokenDispatch()
  const { clearCart } = useCartController()

  return useCallback(
    error => {
      if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status.toString() === '423'
      ) {
        clearCart()
        setTokenDB({})
      }
    },
    [clearCart, setTokenDB],
  )
}

export default useExecuteInCatch
